module.exports = __webpack_public_path__ + "img/link-icon.e9f481db.svg";